import { useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';
import type { IInitOptions, IProductConfiguration } from '@vox/front-configurator';
import styles from '@features/productPreview/sections/FrontConfigurator/FrontConfigurator.styles';
const ClientFrame = dynamic(() => import('@features/productPreview/sections/FrontConfigurator/FrontConfiguratorClientFrame'), {
  ssr: false
});
type ConfiguratorFrameProps = {
  frameKey: string;
  config: IInitOptions;
  data: IProductConfiguration;
  onReady?: () => void;
};
const ConfiguratorFrame = ({
  frameKey,
  config,
  data,
  onReady
}: ConfiguratorFrameProps) => {
  const mainFrameRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (onReady && mainFrameRef.current) {
      onReady();
    }
  }, [onReady]);
  return <div id="configurator-front" sx={styles.configuratorContainer} ref={mainFrameRef}>
      <ClientFrame key={frameKey} frameKey={frameKey} config={config} data={data} />
    </div>;
};
export default ConfiguratorFrame;